import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-ticket-attach',
  templateUrl: './ticket-attach.component.html',
  styleUrl: './ticket-attach.component.scss'
})
export class TicketAttachComponent {



  constructor( private http: HttpClient, private route: ActivatedRoute) {


  };

  

  ngOnInit(): void {
    this.route.params.subscribe(params => {

      const idEmpresa = params['idEmpresa'];
      const idTicket = params['idTicket'];
      const nomeArquivo = params['nomeArquivo'];
       
      
        this.http.get<any>(`${environment.apiUrl}/ticket/attach/${idEmpresa}/${idTicket}/${nomeArquivo}` ).subscribe(
          (response) => {
            window.location.href = response;

          },
          (error) => {
            console.error('Error:', error);
          });

    });
  }


}

